// @owners { team: patients-team }
import { type PlansEndpointCreateParams } from '@alto/scriptdash/alto/med_sync/patients/v1/plans_endpoint';
import { post } from '~shared/helpers/apiHelper';
import { useMutation, useQueryClient } from '~shared/react-query';

/**
 * @deprecated prefer using auto-generated endpoints directly with `apiEndpointHandler`
 * @see https://github.com/scriptdash/clients/pull/7913
 */
const createMedSyncPlan = async ({ prescription_ids }: PlansEndpointCreateParams) => {
  return post(
    `/med_sync/plans`,
    {
      params: { prescription_ids },
    },
    {
      version: 'v1',
    },
  );
};

/**
 * @deprecated prefer using auto-generated endpoints directly with `apiEndpointHandler`
 * @see https://github.com/scriptdash/clients/pull/7913
 */
export const useCreateMedSyncPlan = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createMedSyncPlan,
    mutationKey: ['med-sync-plan'],
    onSuccess: () => {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @alto/prefer-query-key-factory
      queryClient.invalidateQueries({ queryKey: ['med-sync-preliminary-prescriptions'] });
    },
  });
};
